import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';

export default class AgregarFaq extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            preguntaLongitud:0,
            resource: {
                faq_Pregunta:"",
                faq_Respuesta:"",
                cfaq_Id:0,
                faq_Orden:this.props.location.state !== undefined ? this.props.location.state.totalRegistros + 1 : "",
                faq_Activo:true
            },
            Validacion: {
                faq_Pregunta: {
                    Error: false,                    
                },
                faq_Respuesta: {
                    Error: false,                    
                },
                cfaq_Id: {
                    Error: false,                    
                },
                faq_Orden: {
                    Error: false,                    
                },
                faq_Activo: {
                    Error: false,                    
                }
            },
            categorias: [],          
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);

      }
    
    handleClickCancel(e) {

        e.preventDefault();

        const {history: {push}} = this.props;    
        push('/faqs');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.faq_Pregunta == '') {              
            newState.Validacion.faq_Pregunta = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.faq_Respuesta == '') {  
            newState.Validacion.faq_Respuesta = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.cfaq_Id == 0) {  
            newState.Validacion.cfaq_Id = {Error: true};
            newState.hasError = true;
        }
        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}FaqUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'faq_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.faq_Pregunta = '';
                stateResponse.resource.faq_Respuesta = '';
                stateResponse.resource.cfaq_Id = 0;
                stateResponse.resource.faq_Orden += 1 ;
                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let preguntaLongitud = this.state.preguntaLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'faq_Pregunta'){
            preguntaLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            preguntaLongitud: preguntaLongitud,
            Validacion: validaciones
        });  
    }

    componentDidMount()
    {
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/faqs";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol); 
        
        const url = `${API_URL}FaqUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    categorias: data.result.categorias
                });
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Agregar Pregunta Frecuente</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Pregunta Frecuente
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> : null
                }   

                {
                    this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Pregunta" name='faq_Pregunta' value={this.state.resource.faq_Pregunta} maxLength={220} className={this.state.Validacion.faq_Pregunta.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={220}>{this.state.preguntaLongitud}/220</span>
                    </div>

                    <div className="textareaResumen x-1">
                        <textarea placeholder="Respuesta" value={this.state.resource.faq_Respuesta} name="faq_Respuesta" className={this.state.Validacion.faq_Respuesta.Error ? "error" : ""} onChange={this.handleInputChange}/>
                    </div>	

                    <div className="txtFile x-1">
                        <select name='cfaq_Id' id='cfaq_Id' onChange={this.handleInputChange} className={this.state.Validacion.cfaq_Id.Error ? "error" : ""}>
                            <option value="0">Seleccionar Categoría</option>
                            {
                                this.state.categorias.length > 0 ?
                                this.state.categorias.map((categoria) => (
                                    <option value={categoria.id}>{categoria.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>                        
                    </div>

                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='faq_Orden' value={this.state.resource.faq_Orden} maxLength={2} className={this.state.Validacion.faq_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

            </div>
        )
    }
}